import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { SegnalazioniService } from './eventi-segnalazioni.service';

@Injectable({
  providedIn: 'root'
})
export class GestioneSegnalazioniDataSource implements DataSource<ModelEventiCalamitosi.SegnalazioneDaInviareDTO> {

  private segnalazioneSubject = new BehaviorSubject<ModelEventiCalamitosi.SegnalazioneDaInviareDTO[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  private errorSubject = new BehaviorSubject<boolean>(false);
  public errors$ = this.errorSubject.asObservable();
  isLoading: boolean = false;
  errorMessage: string = null;

  private countSubject = new BehaviorSubject<number>(0);
  public counter$ = this.countSubject.asObservable();

  constructor(private segnalazioniSvc: SegnalazioniService) {
  }

  loadSegnalazioniDaInviare(
    ipa: string,
    filter: ModelEventiCalamitosi.SegnalazioneDaInviareDTO,
    sortDirection: string,
    pageIndex: number,
    pageSize: number,
    idEnte: number
  ) {

    this.loadingSubject.next(true);

    this.segnalazioniSvc.getSegnalazioniDaInviare(idEnte, pageIndex, pageSize, sortDirection, {
      idInvio: filter.idInvio,
      dpgr: filter.dpgr,
      dataEventoDa: filter.dataEventoDa,
      dataEventoA: filter.dataEventoA,
      stato: filter.stato,
      fileCaricato: filter.fileCaricato,
      dataProtoRve: filter.dataProtoRve,
      numProtoRve: filter.numProtoRve,
      dataProtoEnteAt: filter.dataProtoEnteAt,
      numProtoEnteAt: filter.numProtoEnteAt,
      dataCreazione: filter.dataCreazione
    }).pipe(
      catchError(err => {
        this.errorSubject.next(true);
        return throwError(err);
      }),
      catchError(err => {
        return of([]);
      }),
      finalize(() => {
        this.loadingSubject.next(false)
      })
    )
      .subscribe(result => {
        // console.log(result['content'])
        this.segnalazioneSubject.next(result['content']);
        this.countSubject.next(result['totalElements']);
      }
      );
  }

  connect(collectionViewer: CollectionViewer): Observable<ModelEventiCalamitosi.SegnalazioneDaInviareDTO[]> {
    return this.segnalazioneSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.segnalazioneSubject.complete();
    this.loadingSubject.complete();
  }

}

